var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1409 11.0933C13.7168 12.0963 13.0534 12.9801 12.2088 13.6675C11.3642 14.3549 10.3641 14.8249 9.29588 15.0365C8.22766 15.248 7.12387 15.1947 6.08102 14.8811C5.03817 14.5676 4.088 14.0033 3.3136 13.2377C2.5392 12.4721 1.96413 11.5284 1.63868 10.4892C1.31322 9.45004 1.24729 8.34694 1.44665 7.27637C1.64601 6.2058 2.10458 5.20036 2.78228 4.34797C3.45998 3.49557 4.33617 2.82216 5.33425 2.38661M14.0009 8.49995C14.3689 8.49995 14.6709 8.20061 14.6343 7.83461C14.4806 6.30406 13.8023 4.87375 12.7145 3.78616C11.6266 2.69857 10.1962 2.02064 8.66559 1.86728C8.29892 1.83061 8.00025 2.13261 8.00025 2.50061V7.83395C8.00025 8.01076 8.07049 8.18033 8.19552 8.30535C8.32054 8.43038 8.49011 8.50061 8.66692 8.50061L14.0009 8.49995Z",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.a979710de9b3591a2b9a5e7f2c6026ed.svg";
export { ForwardRef as ReactComponent };